import { Rule } from '../components/Rule';
import { Vine } from '../components/Vine';
import { couple, day, venue } from '../content/wedding';

/** Load stagger, in ms — one orchestrated entrance rather than many small ones. */
const beat = (i: number) => ({ animationDelay: `${140 + i * 170}ms` });

export function Hero() {
  return (
    <section class="hero">
      <Vine />
      <div class="shell hero__content">
        <h1 class="hero__names">
          <span class="rise" style={beat(0)}>
            {couple.one.first}
          </span>
          <span class="hero__amp rise" style={beat(1)}>
            &amp;
          </span>
          <span class="rise" style={beat(2)}>
            {couple.two.first}
          </span>
        </h1>

        <div class="hero__meta">
          <Rule class="hero__rule rise" />
          <p class="hero__date rise" style={beat(3)}>
            {day.dateShort}
          </p>
          <p class="hero__where rise" style={beat(4)}>
            {venue.name}, {venue.place}
          </p>
        </div>
      </div>
    </section>
  );
}
